// extracted by mini-css-extract-plugin
module.exports = {"props_title":"styles_props_title__1UGnL","props_wrapper":"styles_props_wrapper__1pKlI","props_button":"styles_props_button__27lZK","active":"styles_active__OOfkJ"};